export module ErrorMessages {
    export const reportRequestFailed = `Oops, we encountered an error while processing your query.`;
    export const reportRequestTooComplex = 'Sorry, the geometry you are trying to query is too complex/large for our area query service.';
    export const reportRequestTimedOut = 'Query request timed out.'
    export const areaRequestTimedOut = 'Request timed out. This may have occurred because the load on our server is high. It may also occur if the area you queried is large and/or highly complex.'
}
